import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

const Form = () => {
  const history = useHistory();
  const { addToast } = useToasts();
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [phone, setphone] = useState("");
  const [value, setvalue] = useState(false);

  const checkdisable = () => {
    if (!value) return true;
    if (!name) return true;
    if (!phone) return true;
    if (phone.length !== 10) return true;
    if (!email) return true;
    if (email) {
      let exp = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
      if (email.match(exp)) {
        return false;
      } else {
        return true;
      }
    }
  };
  const handlesubmit = () => {
    setname("");
    setemail("");
    addToast("Number Registered Successfully", {
      appearance: "success",
      autoDismiss: true,
    });
    setTimeout(() => {
      history.push("/registration/customer-information");
    }, 2000);
  };
  return (
    <div id="myForm">
      <div>
        <img
          alt="logo"
          src="./loginlogo.png"
          style={{ width: "100px", height: "100px" }}
        />
        <div className="row mt-4 mx-0">
          <input
            value={name}
            onChange={(e) => setname(e.target.value)}
            placeholder="Name"
            className="form-control"
          />
        </div>
        <div className="row mt-4 mx-0">
          <input
            value={email}
            onChange={(e) => setemail(e.target.value)}
            type="email"
            placeholder="Email"
            className="form-control"
          />
        </div>
        <div className="row mt-4 mx-0">
          <input
            value={phone}
            onChange={(e) => setphone(e.target.value)}
            placeholder="Phone Number"
            className="form-control"
          />
        </div>
        <p className="phone_instruction marginp">
          <input
            type="checkbox"
            onChange={(e) => {
              if (e.target.checked) {
                setvalue(true);
              } else {
                setvalue(false);
              }
            }}
            style={{ marginRight: "10px", marginTop: "7px" }}
          />
          <span>
            By checking this box, I agree to Amcrest{" "}
            <a
              target="_blank"
              href="https://amcrestgps.net/terms/"
              rel="noreferrer"
              className="termslink"
            >
              terms & conditions
            </a>{" "}
            and{" "}
            <a
              target="_blank"
              href="https://amcrestgps.net/terms/"
              rel="noreferrer"
              className="termslink"
            >
              privacy policy
            </a>{" "}
            and consent to receive SMS alerts.
          </span>
        </p>
        <button
          disabled={checkdisable()}
          className="btn btn-primary w-100 mt-4"
          onClick={handlesubmit}
        >
          Submit
        </button>

        {/* <p className="phone_instruction marginp">
          By completing this form, you also give consent to Amcrest to send SMS
          related to your device alerts.
        </p> */}
        <p className="phone_instruction marginp">
          <strong> Pricing</strong> : Message and data rates may apply
        </p>
        <p className="phone_instruction marginp">
          <strong>Message Frequency</strong> : Message frequency varies. Daily,
          you may get 2 to 3 messages.
        </p>
        <p className="phone_instruction marginp">
          For HELP or to STOP sms alerts, mail us at{" "}
          <a href="mailto:amcrestgpssupport@amcrest.com">
            amcrestgpssupport@amcrest.com.
          </a>
        </p>
      </div>
    </div>
  );
};

export default Form;
